var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtChipCollege = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h50v50H0V0z",
    id: "ppgsvuo2ua"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#ppgsvuo2ua"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(4.167 5.833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.099 16.405v7.976a11.508 11.508 0 0 0 3.239 3.764c1.98 1.478 3.9 1.826 6.27 2.272 3.538.666 6.364.36 7.716.154 2.686-.411 4.438-1.183 4.965-1.425 0 0 2.712-1.247 3.944-2.917.52-.706.815-1.459.815-1.459a5.82 5.82 0 0 0 .204-.61v-7.838",
    fill: "#4B98AA"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#49848E",
    d: "M0 12.04v1.578L20.698 25.67l.015-1.641"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#317A82",
    d: "m41.667 12.121-.008 1.58L20.697 25.67l-.015-1.63"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#72BBCC",
    d: "M.002 12.017 20.728 0l20.939 12.121-20.925 12.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.249 11.076v.687c.14.1.351.236.632.345.166.065 1.107.428 1.966-.015a1.91 1.91 0 0 0 .533-.412l.03-.754",
    fill: "#49ACBC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#72BBCC",
    cx: 20.833,
    cy: 11.04,
    rx: 1.576,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.107 10.538 15.501 8.785c.005.014.071.253-.071.407-.14.152-.433.166-.646-.024L20.5 10.761a.696.696 0 0 1 .57-.238",
    fill: "#72BBCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.597 11.382 15.312 9.11c.013-.002.255-.063.32-.262.063-.197-.07-.458-.34-.548l-15.395-8.935a.723.723 0 0 0-.036.297c.015.15.074.26.109.315",
    fill: "#49ACBC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C75F",
    d: "m35.392 26.204-2.322 3.09v8.566l.791.473v-8.71l2.511-3.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAE4AE",
    d: "m36.15 26.515-2.314 3.108.025 8.71 5.042-2.877.026-8.66-2.264-.637"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#72BBCC",
    d: "M36.132 19.353v7.267l.65-.434-.151-6.858"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#49ACBC",
    d: "M35.36 19.807v6.411l.768.426.004-6.804"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    transform: "rotate(-52.64 36.443 27.456)",
    cx: 36.443,
    cy: 27.456,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.316 29.554c-.24 0-.646.039-1.064.277-.68.387-.91 1.03-.998 1.273-.1.277-.218.62-.099 1.013.044.147.136.449.393.57.294.14.498-.103 1.015-.016.187.032.395.066.507.23.207.3-.09.8-.148.897-.243.41-.62.59-.818.686-.38.182-.737.224-.982.229l-.087.47c.141.038.382.086.672.054.975-.107 1.51-.994 1.587-1.127.096-.166.249-.422.286-.797.026-.253.079-.65-.17-.958-.231-.283-.594-.335-.834-.368-.305-.042-.5.152-.68.036-.111-.07-.147-.194-.171-.277-.11-.375.107-.74.223-.931.13-.214.261-.329.296-.359.076-.063.195-.162.376-.223.186-.061.352-.054.574-.045.089.005.163.012.216.018l.003-.652",
    fill: "#4B98AA"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B98AA",
    d: "m36.68 29.98-.05-1.133-.495.124.065.916M36.221 34.716l.026 1.133.497-.113-.045-.918"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtChipCollege);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-chip-college.5609b274481fc96243bb7fae98848243.svg";